import { CellContext } from "@tanstack/react-table";
import { useState } from "react";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { SelectFieldOption_Values } from "../../../Definitions";
import NewSelect from "../../BaseComponents/newSelect";
import { NewFieldStyles, NewFieldTypes } from "../../../Definitions/newFieldStyles";
import { SelectFieldTableOption } from "../_Tables/useColumnConstructor";

interface ListOptions<T> {
  options: SelectFieldTableOption<T>
}

export const ListTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, divStyleOverride, styleOverrideOnValue = true, options, cell}: CellContext<T, SelectFieldOption_Values | undefined> & EditAbleCell & ListOptions<T>) => {
  const initialValue = getValue();

  const [value, setValue] = useState(initialValue);

  const divStyle = divStyleOverride ? divStyleOverride(styleOverrideOnValue ? value?.label : row.original.id) : undefined;

  const onChange = (newValue: SelectFieldOption_Values) => {
    setValue(newValue)
    if (newValue?.id !== initialValue?.id) {
      table.options.meta?.updateData(row.original.id, column.id, newValue, row);
    }
  }

  return <ListStringCell options={typeof options === "function" ? options(row) : options} staticColumn={staticColumn} key={cell.id} keyPass={cell.id+"Input"} onChange={onChange} canEdit={canEdit} cellData={{value, style: divStyle}} />
}

const ListStringCell = ({onChange, canEdit, cellData, keyPass, staticColumn, options}: StyledTableCellProps & EditAbleCell & {options: SelectFieldOption_Values[]}) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style, opacity: 0.5  }} key={keyPass}>
          {String(cellData.value.label ?? "") ?? ''}
        </div>
      );
    } else {
      return <NewSelect
        options={options}
        fieldOverrides={{
          fieldStyle: NewFieldStyles.greyTertiary,
          fieldType: NewFieldTypes.tertiaryField,
          fieldWidth: "100%",
          menuWidth: "280px"
        }}
        onChange={onChange}
        key={keyPass}
        valueOverrides={{ // TODO: Doesn't show defaultValue
          defaultValue: cellData.value
        }}
      />;
    }
  }

  return (
    <div style={cellData.style} key={keyPass}>
      {String(cellData.value.label ?? "")}
    </div>
  )
}